import React, {Component, PropTypes} from 'react'
import moment from 'moment'
import cx from 'classnames'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import phonez from '../../core/phonez'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import {Ticket} from '../models'
import style from './TicketCard.less'

class TicketCard extends Component {
    static propTypes = {
        ticket: PropTypes.object.isRequired
    }

    render() {
        const {ticket, ...others} = this.props

        const header = (
            <h5>ticket <small>n° {ticket.ref}</small></h5>
        )

        const help = (
            <div>
                <Icon icon='clock' size='xs' />
                <span>{moment(ticket.dates.created).format(i18n.creationDateTimeFormat)}</span>
            </div>
        )

        const addon = (
            <Icon icon='status-success' size='xs' />
        )

        return (
            <div className={style.default}>
                <Card
                    kind='tab'
                    status='success'
                    header={header}
                    help={help}
                    addon={addon}
                    {...others}>
                    <Row className='no-gutter'>
                        <Col xs={10} sm={4}>
                            <div className={style.purpose}>
                                <h5>> {ticket.openingTicketPurpose.callPurpose}</h5>
                            </div>
                        </Col>
                        <Col xs={2} sm={8}>
                            <div className={style.status}>
                                <Icon icon={Ticket.accurateStatus(ticket)} size='sm' />
                                <h5>> {i18n.status} : <small>{extract(i18n.statusEnum, ticket.status)}</small></h5>
                            </div>
                        </Col>                    
                    </Row>
                    <Row className='no-gutter'>
                        <Col sm={4}>
                            <div className={style.caller}>
                                <h5>{ticket.caller.name}</h5>
                                <p>{ticket.address.quality}</p>
                                <p>{ticket.address.number} {ticket.address.street}</p>
                                <p>{ticket.address.zipCode} {ticket.address.city}</p>
                                <p>{ticket.address.complement}</p>
                            </div>
                        </Col>
                        <Col xsHidden sm={4}>
                            <div className={style.assignee}>
                                {ticket.assignee && (
                                    <div>
                                        <h5>{i18n.assignee}</h5>
                                        <p className={style.capitalize}>{ticket.assignee.name}</p>
                                        {ticket.assignee.phones.map((phone, index) => (
                                            <p key={index}>{phonez(phone).format()}</p>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className={style.state}>
                                <div className={style.stateContent}>
                                    <h5>{i18n.state}</h5>
                                    <p className={style.capitalize}>{extract(i18n.stateEnum, ticket.state && ticket.state.value || 'TicketOpened')}</p>
                                    {ticket.state && (
                                        <div>
                                            <p>{moment(ticket.state.date).format(i18n.dateFormat.long)}</p>
                                            <p>{moment(ticket.state.date).format(i18n.timeFormat.long)}</p>
                                        </div>
                                    )}
                                </div>
                            </div>                            
                        </Col>                    
                    </Row>
                </Card>
            </div>
        )
    }
}

export default TicketCard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketCard.js